/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type StorefrontProductGrid_viewer$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type StorefrontFeaturedSection_viewer$ref: FragmentReference;
export type StorefrontFeaturedSection_viewer = {|
  +$fragmentRefs: StorefrontProductGrid_viewer$ref,
  +$refType: StorefrontFeaturedSection_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "StorefrontFeaturedSection_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "StorefrontProductGrid_viewer",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'd7f364a176f42757299c334987f84e09';
module.exports = node;
